module.exports = __webpack_public_path__ + "img/file-break.0df7d195.svg";